import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { UtilsCopyButtonModule } from '@unico-people/shared/utils/utils-copy-button';

import { UiCopyButtonComponent } from './ui-copy-button.component';

@NgModule({
  declarations: [UiCopyButtonComponent],
  imports: [CommonModule, UtilsCopyButtonModule, MatSnackBarModule],
  exports: [UiCopyButtonComponent]
})
export class UiCopyButtonModule {}
